import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { Action } from '@ngrx/store';
import { createReducer, on } from '@ordersnproducts/utils/create-reducer';
import CxShippingConditionActions from '../actions/cx-shipping-condition.actions';
import { CxShippingCondition } from '../../models/shipping-condition';

export type CxShippingConditionEntity = CxShippingCondition;
export interface CxShippingConditionState extends EntityState<CxShippingConditionEntity> {
  activeEntityId: string;
}

export const entityAdapter = createEntityAdapter<CxShippingConditionEntity>({
  selectId: ({ shippingConditionId }) => `${shippingConditionId}`,
});

export const initialCxShippingConditionState = entityAdapter.getInitialState({
  activeEntityId: null,
});

export const cxShippingConditionReducer = createReducer(
  initialCxShippingConditionState,

  on(CxShippingConditionActions.selectEntity, (state, { id: activeEntityId }) => {
    return {
      ...state,
      activeEntityId,
    };
  }),

  on(CxShippingConditionActions.updateEntity, (state, { payload }) => entityAdapter.upsertOne(payload, state)),
  on(CxShippingConditionActions.updateEntities, (state, { payload }) => entityAdapter.upsertMany(payload, state)),
);

export function reducer(state: CxShippingConditionState, action: Action) {
  return cxShippingConditionReducer(state, action);
}

export const selectActiveEntityId = (state: CxShippingConditionState) => state.activeEntityId;
export const { selectIds, selectEntities, selectAll, selectTotal } = entityAdapter.getSelectors();
